import { PATH_TO_KEYCLOAK } from "./constants";
import Keycloak from "keycloak-js";

const kc = new Keycloak(PATH_TO_KEYCLOAK);

export default kc;
